import { formatMeterValue, MeterType } from "@next-platform/packages-ts-types";
import { resolveMeterLevelIndex } from "../formatRulebookMeter";
/** Dice hold 0 until their first roll. */
const NOT_ROLLED = "—";
const CLOCK_SEPARATOR = " · ";
const DAY_COUNT_PREFIX = "Day ";
/** Calendar clocks keep the weekday and time ("Tue 15:30"); day counts keep the day ("Day 3 · 18:40"). */
const clockText = (label) => {
    const [date = "", time] = label.split(CLOCK_SEPARATOR);
    if (time === undefined) {
        return { value: label, mini: label };
    }
    const weekday = date.split(" ")[0] ?? date;
    return { value: date.startsWith(DAY_COUNT_PREFIX) ? label : `${weekday} ${time}`, mini: time };
};
/** Values shortened for tiles: numbers without their unit, dice as "14 / d20", pips as "3/5", clocks as above. */
export default function hudTileText({ meter, value, clockLabel = "", levelText }) {
    if (meter.type === MeterType.CLOCK) {
        return clockText(clockLabel);
    }
    if (meter.type === MeterType.DICE) {
        const face = value < 1 ? NOT_ROLLED : String(value);
        return { value: `${face} / d${meter.sides ?? meter.max ?? ""}`, mini: face };
    }
    if (meter.type === MeterType.NUMBER) {
        const text = meter.display === "level" ? levelText(resolveMeterLevelIndex({ levels: meter.levels, value }) + 1) : formatMeterValue(meter, value);
        return { value: text, mini: text };
    }
    if (meter.type === MeterType.PIPS) {
        const min = meter.min ?? 0;
        return { value: `${value - min}/${(meter.max ?? min) - min}`, mini: String(value - min) };
    }
    return { value: String(value), mini: String(value) };
}
